import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import useStyles from './styles'
import LoaderButton from 'components/LoaderButton'
import PhoneInput from 'react-phone-number-input'
import { joinUser } from 'actions/event'
import { sendPin } from 'actions/authentication'
import PinInput from './PinInput'
import { FormHelperText } from '@material-ui/core'
import { login } from 'actions/authentication'
import { openSnackBar } from 'actions/snack-bar'

const countries = ['US', 'AU', 'HK', 'NZ', 'SG', 'CA', 'MO', 'GB', 'BE']

const LoginForm = ({ onComplete }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const { eventId } = useParams()

  const [isPin, setIsPin] = useState(false)
  const [country, setCountry] = useState('US')

  const LoginSchema = Yup.object().shape({
    phone: Yup.string().required('Required')
  })

  const PinSchema = Yup.object().shape({
    pin: Yup.string().required('Required')
  })

  const loginForm = useFormik({
    initialValues: {
      phone: ''
    },
    validationSchema: LoginSchema,
    onSubmit: (values, actions) => {
      dispatch(
        joinUser({
          user_phone: values.phone,
          eid: eventId,
          send_sms: false
        })
      )
        .then(() => {
          dispatch(sendPin(values.phone))
            .then(() => {
              actions.setSubmitting(false)
              setIsPin(true)
            })
            .catch(err => {
              actions.setSubmitting(false)
              console.error(err)
              dispatch(
                openSnackBar({
                  message: 'There was an issue trying to log you in'
                })
              )
            })
        })
        .catch(err => {
          actions.setSubmitting(false)
          console.error(err)
          dispatch(
            openSnackBar({
              message: 'There was an issue trying to log you in'
            })
          )
        })
    }
  })

  const pinForm = useFormik({
    initialValues: {
      pin: ''
    },
    validationSchema: PinSchema,
    onSubmit: (values, actions) => {
      dispatch(
        login({
          user_phone: loginForm.values.phone,
          user_pin: values.pin
        })
      )
        .then(res => {
          // dispatch(
          //   openSnackBar({
          //     message: 'Logged in successfully'
          //   })
          // )
          onComplete(res)
        })
        .catch(err => {
          console.error(err)
          dispatch(
            openSnackBar({
              message: 'Pin number was incorrect'
            })
          )
        })
        .finally(() => actions.setSubmitting(false))
    }
  })

  const handlePhoneChange = val => {
    loginForm.setFieldValue('phone', val)
  }

  const handlePinChange = val => {
    pinForm.setFieldValue('pin', val)
  }

  if (!isPin) {
    return (
      <form onSubmit={loginForm.handleSubmit} classes={classes.form}>
        <PhoneInput
          name="phone"
          value={loginForm.values.phone}
          onChange={handlePhoneChange}
          onCountryChange={country => setCountry(country)}
          country={country}
          countries={countries}
          placeholder="Mobile Number"
          className="login-phone"
          autoFocus
        />
        <div style={{ marginTop: '34px' }}>
          <LoaderButton
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
            classes={{ button: classes.submit }}
            working={loginForm.isSubmitting}
          >
            Sign In
          </LoaderButton>
        </div>
      </form>
    )
  } else {
    return (
      <form onSubmit={pinForm.handleSubmit} classes={classes.form}>
        <PinInput
          phone={loginForm.values.phone}
          value={pinForm.values.pin}
          onChange={handlePinChange}
        />
        {pinForm.errors.pin && (
          <FormHelperText error>
            Please enter the full pin number
          </FormHelperText>
        )}
        <div style={{ marginTop: '34px' }}>
          <LoaderButton
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
            classes={{ button: classes.submit }}
            working={pinForm.isSubmitting}
          >
            Submit
          </LoaderButton>
        </div>
      </form>
    )
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/LoginForm/index.jsx